"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var EstimateReentryModal_1 = __importDefault(require("~/components/modal/EstimateReentryModal"));
var EstimateFuyoReentryModal_1 = __importDefault(require("~/components/modal/EstimateFuyoReentryModal"));
var estimate_reentry_modal_store_1 = __importDefault(require("~/stores/modal/users/estimate_reentry_modal_store"));
var EstimateReentryModal = function (props) {
    var store = new estimate_reentry_modal_store_1.default(props);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(EstimateReentryModal_1.default, { store: store.reentryModalStore }),
        react_1.default.createElement(EstimateFuyoReentryModal_1.default, { store: store.fuyoReentryModalStore })));
};
exports.default = EstimateReentryModal;
